export function formatMs(ms) {
  if (ms < 0) return '—';
  if (ms < 1000) return `${ms}ms`;
  return `${(ms / 1000).toFixed(1)}s`;
}

export function formatDecimalDisplay(val, maxDecimals = 2) {
  if (typeof val === 'number' && Number.isFinite(val)) {
    return val.toFixed(maxDecimals);
  }

  if (typeof val === 'string' && val.trim() !== '') {
    const parsed = Number(val);
    if (Number.isFinite(parsed)) {
      return parsed.toFixed(maxDecimals);
    }
  }

  return null;
}

export function formatValue(val) {
  if (val === null) return 'null';
  if (val === undefined) return 'undefined';
  if (typeof val === 'object') return JSON.stringify(val);
  if (val === '') return "''";
  return String(val);
}

export function truncateUrl(url, maxLen = 80) {
  if (!url || url.length <= maxLen) return url || '';
  return url.slice(0, maxLen - 3) + '...';
}
